<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 搜索区 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="销售姓名">
                <a-input v-model="queryParam.salesName" allow-clear placeholder="模糊查询"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="推广短码">
                <a-input v-model="queryParam.salesCode" allow-clear placeholder="精确查询"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="应用端">
                <a-select v-model="queryParam.appIdent" allow-clear placeholder="全部">
                  <a-select-option value="guzhu">雇主端</a-select-option>
                  <a-select-option value="shifu">师傅端</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item label="日期范围">
                <a-range-picker
                  v-model="queryParam.dateRange"
                  allow-clear
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  style="width: 100%"
                  :placeholder="['开始日期', '结束日期']"
                />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span :style="advanced && { float: 'right', overflow: 'hidden' } || {}" class="table-page-search-submitButtons">
                <a-button type="primary" :loading="loading" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 汇总卡片 -->
      <div class="summary-row">
        <div class="summary-card">
          <div class="summary-card__label">扫码 PV</div>
          <div class="summary-card__value">{{ total.scanPv }}</div>
          <div class="summary-card__hint">区间内访问次数（按事件）</div>
        </div>
        <div class="summary-card">
          <div class="summary-card__label">扫码 UV</div>
          <div class="summary-card__value">{{ total.scanUv }}</div>
          <div class="summary-card__hint">distinct visitor_id</div>
        </div>
        <div class="summary-card">
          <div class="summary-card__label">下载点击</div>
          <div class="summary-card__value">{{ total.downloadClick }}</div>
          <div class="summary-card__hint">点击「前往 App Store / 应用市场 / 下载 APK」</div>
        </div>
        <div class="summary-card">
          <div class="summary-card__label">点击转化率</div>
          <div class="summary-card__value">{{ total.clickRate }}</div>
          <div class="summary-card__hint">下载点击 / 扫码 UV</div>
        </div>
      </div>

      <!-- 趋势图 -->
      <a-card title="按天趋势" size="small" class="chart-card">
        <div ref="trendChart" class="chart"></div>
      </a-card>

      <!-- 明细表 -->
      <a-card title="按销售 × 端 明细" size="small" class="detail-card">
        <a-table
          :columns="detailColumns"
          :data-source="detail"
          :pagination="false"
          :loading="loading"
          rowKey="rowKey"
          size="small"
          :scroll="{ x: 1000 }"
        >
          <span slot="appIdent" slot-scope="text">
            <a-tag v-if="text === 'guzhu'" color="blue">雇主端</a-tag>
            <a-tag v-else-if="text === 'shifu'" color="green">师傅端</a-tag>
            <span v-else>-</span>
          </span>
          <span slot="clickRate" slot-scope="text">
            {{ text }}%
          </span>
        </a-table>
      </a-card>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import * as echarts from 'echarts'
import { getPromotionStats } from '@/api/promotion/sales'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'PromotionStats',
  mixins: [tableMixin],
  data() {
    return {
      loading: false,
      advanced: false,
      queryParam: this.buildQueryParam(),
      summary: { totalScanPv: 0, totalScanUv: 0, totalDownloadClick: 0 },
      detail: [],
      trend: [],
      trendChart: null,
      detailColumns: [
        { title: '销售姓名', dataIndex: 'salesName', width: 130, align: 'center', fixed: 'left' },
        { title: '推广短码', dataIndex: 'salesCode', width: 130, align: 'center' },
        { title: '应用端', dataIndex: 'appIdent', width: 100, align: 'center', scopedSlots: { customRender: 'appIdent' } },
        { title: '扫码 PV', dataIndex: 'scanPv', width: 100, align: 'center' },
        { title: '扫码 UV', dataIndex: 'scanUv', width: 100, align: 'center' },
        { title: '下载点击', dataIndex: 'downloadClick', width: 100, align: 'center' },
        { title: '点击转化率', dataIndex: 'clickRate', width: 120, align: 'center', scopedSlots: { customRender: 'clickRate' } }
      ]
    }
  },
  computed: {
    total() {
      const { totalScanPv, totalScanUv, totalDownloadClick } = this.summary
      const rate = totalScanUv > 0
        ? ((totalDownloadClick / totalScanUv) * 100).toFixed(1)
        : '0.0'
      return {
        scanPv: totalScanPv,
        scanUv: totalScanUv,
        downloadClick: totalDownloadClick,
        clickRate: rate + '%'
      }
    }
  },
  created() {
    // 支持从列表页带参跳转
    const q = this.$route.query || {}
    if (q.salesCode) this.queryParam.salesCode = q.salesCode
    if (q.salesName) this.queryParam.salesName = q.salesName
    this.fetch()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.trendChart) {
      this.trendChart.dispose()
      this.trendChart = null
    }
  },
  methods: {
    buildQueryParam() {
      return {
        salesName: undefined,
        salesCode: undefined,
        appIdent: undefined,
        beginDate: undefined,
        endDate: undefined,
        dateRange: []
      }
    },
    buildSearchParams() {
      const params = {
        salesName: this.queryParam.salesName,
        salesCode: this.queryParam.salesCode,
        appIdent: this.queryParam.appIdent
      }
      if (this.queryParam.dateRange && this.queryParam.dateRange.length === 2) {
        params.beginDate = this.queryParam.dateRange[0]
        params.endDate = this.queryParam.dateRange[1]
      }
      return params
    },
    handleQuery() {
      this.fetch()
    },
    resetQuery() {
      this.queryParam = this.buildQueryParam()
      this.fetch()
    },
    fetch() {
      this.loading = true
      getPromotionStats(this.buildSearchParams()).then(res => {
        const data = res.data || {}
        this.summary = {
          totalScanPv: data.totalScanPv || 0,
          totalScanUv: data.totalScanUv || 0,
          totalDownloadClick: data.totalDownloadClick || 0
        }
        this.detail = (data.items || []).map(it => ({
          ...it,
          // 转化率已经后端算了；这里再保留一份展示精度
          clickRate: (it.clickRate != null ? it.clickRate : 0).toFixed(2),
          rowKey: `${it.salesCode || ''}_${it.appIdent || ''}`
        }))
        this.trend = data.trend || []
        this.$nextTick(() => this.renderChart())
      }).finally(() => {
        this.loading = false
      })
    },
    renderChart() {
      if (!this.$refs.trendChart) return
      if (!this.trendChart) {
        this.trendChart = echarts.init(this.$refs.trendChart)
      }
      const dates = this.trend.map(t => t.date)
      const pv = this.trend.map(t => t.scanPv || 0)
      const uv = this.trend.map(t => t.scanUv || 0)
      const click = this.trend.map(t => t.downloadClick || 0)
      this.trendChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['扫码 PV', '扫码 UV', '下载点击'], top: 0 },
        grid: { left: 40, right: 20, top: 40, bottom: 30 },
        xAxis: { type: 'category', data: dates, boundaryGap: false },
        yAxis: { type: 'value' },
        series: [
          { name: '扫码 PV', type: 'line', smooth: true, areaStyle: {}, data: pv, itemStyle: { color: '#1890ff' } },
          { name: '扫码 UV', type: 'line', smooth: true, data: uv, itemStyle: { color: '#52c41a' } },
          { name: '下载点击', type: 'line', smooth: true, data: click, itemStyle: { color: '#fa8c16' } }
        ]
      })
    },
    handleResize() {
      if (this.trendChart) {
        this.trendChart.resize()
      }
    }
  }
}
</script>

<style scoped>
.summary-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}
.summary-card {
  background: linear-gradient(180deg, #ffffff 0%, #fafbff 100%);
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 20px 24px;
}
.summary-card__label {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}
.summary-card__value {
  font-size: 28px;
  font-weight: 600;
  color: #1890ff;
  line-height: 1.2;
}
.summary-card__hint {
  font-size: 12px;
  color: #bbb;
  margin-top: 6px;
}
.chart-card {
  margin-bottom: 16px;
}
.chart {
  width: 100%;
  height: 320px;
}
.detail-card {
  margin-bottom: 16px;
}
@media (max-width: 992px) {
  .summary-row {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
